import naturalCompare from "./naturalCompare"

const getSortItems = (sortingKey, sortingType, itemsKeys, itemsData, fallbackKey) => {

    const sortedItems = itemsKeys.sort(function(a, b) {
        const itemA = itemsData[a]
        const itemB = itemsData[b]

        const aValue = fallbackKey ? (itemA[sortingKey] || itemA[fallbackKey]) : itemA[sortingKey]
        const bValue = fallbackKey ? (itemB[sortingKey] || itemB[fallbackKey]) : itemB[sortingKey]
        
        if('alphabetical' === sortingType) {
            return naturalCompare(aValue, bValue)
        } else if('date' === sortingType)  {
            return new Date(bValue) - new Date(aValue);
        } else {
            return bValue > aValue ? -1 : bValue < aValue ? 1 : 0
        }
    })

    return sortedItems
}

export default getSortItems